import { render, staticRenderFns } from "./ControlTower.vue?vue&type=template&id=80f5656a&scoped=true"
import script from "./ControlTower.vue?vue&type=script&lang=js"
export * from "./ControlTower.vue?vue&type=script&lang=js"
import style0 from "./ControlTower.vue?vue&type=style&index=0&id=80f5656a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f5656a",
  null
  
)

export default component.exports